
import React, { Component } from 'react'
import * as actions from '../../actions'
import { connect } from 'react-redux'
// import CamaraSeguridad from '../../../Camara/containers/CamaraSeguridad'
import { Button, Card } from 'react-bootstrap'
import { IconButton } from '@material-ui/core'
import ReportProblemIcon from '@material-ui/icons/ReportProblem'
import { INTERVALO_MEDIO } from '../../../../config/settings'

class BarrerasCalado extends Component {
  constructor (props) {
    super(props)
    this.abrirBarreraEntrada = this.abrirBarreraEntrada.bind(this)
    this.cerrarBarreraEntrada = this.cerrarBarreraEntrada.bind(this)
    this.abrirBarreraSalida = this.abrirBarreraSalida.bind(this)
    this.cerrarBarreraSalida = this.cerrarBarreraSalida.bind(this)
    this.abrirBarreraSalidaAlternativa = this.abrirBarreraSalidaAlternativa.bind(this)
    this.cerrarBarreraSalidaAlternativa = this.cerrarBarreraSalidaAlternativa.bind(this)
    this.state = { time: 0 }
  }

  componentDidMount () {
    this.props.estadoBarreraSalida()

    this.intervalBarreraSalida = setInterval(() => {
      this.props.estadoBarreraSalida()
    }, INTERVALO_MEDIO)
  }

  componentWillUnmount () {
    clearInterval(this.intervalBarreraSalida)
  }

  abrirBarreraEntrada () {
    this.props.abrirBarreraEntradaCalado()
  }

  cerrarBarreraEntrada () {
    this.props.cerrarBarreraEntradaCalado()
  }

  abrirBarreraSalida () {
    this.props.abrirBarreraSalidaCalado()
    this.setState({ time: 2 })

    this.intervaloEstadoBarrera = setInterval(() => {
      if (this.state.time > 0) {
        this.setState({ time: this.state.time - 1 })
      }
      if (this.state.time === 0) {
        this.props.estadoBarreraSalida()
        clearInterval(this.intervaloEstadoBarrera)
      }
    }, 1000)
  }

  cerrarBarreraSalida () {
    this.props.cerrarBarreraSalidaCalado()
    this.setState({ time: 2 })

    this.intervaloEstadoBarrera = setInterval(() => {
      if (this.state.time > 0) {
        this.setState({ time: this.state.time - 1 })
      }
      if (this.state.time === 0) {
        this.props.estadoBarreraSalida()
        clearInterval(this.intervaloEstadoBarrera)
      }
    }, 1000)
  }

  abrirBarreraSalidaAlternativa () {
    this.props.abrirBarreraSalidaAlternativa()
  }

  cerrarBarreraSalidaAlternativa () {
    this.props.cerrarBarreraSalidaAlternativa()
  }

  render () {
    // const urlEntrada = 'https://laridae.terminalquequen.com.ar/camaras-live/entrada-calado'
    /* const urlSalida = 'https://laridae.terminalquequen.com.ar/camaras-live/salida-calado' */

    const { estadoBarreraCalado } = this.props
    const barreraForzada = (estadoBarreraCalado === 'FORZADO')

    return (
      <div className='container-camaras-calado-general'>
        <Card className='container-camaras-calado shadow bg-white rounded'>
          <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

            {barreraForzada && <div className='alerta-barrera-forzada'>
              <IconButton style={{ color: '#f83a4d', margin: '0 0 0 5%', width: 48 }} ><ReportProblemIcon /></IconButton>
              <h4>Barrera de salida forzada</h4>
            </div> }

            <div>
              <div className='container-barreras-vigilancia'>
                <div className='container-botones-barrera-vigilancia' style={{ margin: '5px' }}>
                  <h4 style={{ margin: '25px' }}>Barrera entrada calado</h4>
                  <div className='acciones-barreras-calado'>
                    <Button className='btn-accion-config-vigilancia btn-primary btn-lg' onClick={this.abrirBarreraEntrada}>Abrir barrera entrada</Button>
                    <Button className='btn-accion-config-vigilancia btn-primary btn-lg' onClick={this.cerrarBarreraEntrada}>Cerrar barrera entrada</Button>
                  </div>
                </div>

                <div className='container-botones-barrera-vigilancia' style={{ margin: '5px' }}>

                  <h4 style={{ margin: '25px' }}>Barrera salida calado</h4>
                  <div className='acciones-barreras-calado'>
                    {/* <Button className='btn-accion-config-vigilancia btn-primary btn-lg' onClick={this.abrirBarreraSalida}>Abrir barrera salida</Button>
                    <Button className='btn-accion-config-vigilancia btn-primary btn-lg' onClick={this.cerrarBarreraSalida}>Cerrar barrera salida</Button> */}
                    <Button className='btn-accion-config-vigilancia btn-primary btn-lg' onClick={this.abrirBarreraSalida}>Forzar barrera salida</Button>
                    <Button className='btn-accion-config-vigilancia btn-primary btn-lg' onClick={this.cerrarBarreraSalida}>Liberar barrera salida</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
        <Card className='container-camaras-calado-alternativa shadow bg-white rounded'>

          <div style={{ margin: '5px', width: '90%' }}>
            <h5 style={{ margin: '3% 0' }}>Barrera alternativa de salida calado</h5>
            <div className='botones-barrera-alternativa'>
              <Button className='btn-accion-config-vigilancia btn-primary btn-lg' onClick={this.abrirBarreraSalidaAlternativa}>Abrir barrera salida alternativa </Button>
              <Button className='btn-accion-config-vigilancia btn-primary btn-lg' onClick={this.cerrarBarreraSalidaAlternativa}>Cerrar barrera salida alternativa</Button>
            </div>
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    estadoBarreraCalado: state.calado.estadoBarreraCalado
  }
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux(BarrerasCalado)
